/*requires hei.js */
//
// Javascript for HEI style guidelines UI
// for navigation systems
//
//  Ben Ramey
//  October 2009
//
HEIJS.Navigation = function ()
{
  if ($('.hbs:first').length > 0) {
    $('div.globalNavMobileHeader:first').addClass('hbs');
  }
  
  this.header = $('div.layerone-nav');
  this.layer1 = $("div.layerone-nav ul.visible-links");
  this.layer2 = $("div.layertwo-nav ul.visible-links.list-1");
  this.layer3 = $("div.layertwo-nav ul.visible-links.list-2");

  if (this.layer1.length == 0
      && this.layer2.length == 0
      && this.layer3.length == 0)
  {
    return;
  }

  var selectedAnchorSelector = "a.visible-anchor-selected, a.flyout-anchor-selected";
  this.layer1.find(selectedAnchorSelector).each(
    function () { $(this).parent()[0].__isActiveTab = true; }
  );
  this.layer2.find(selectedAnchorSelector).each(
    function () { $(this).parent()[0].__isActiveTab = true; }
  );
  this.layer3.find(selectedAnchorSelector).each(
    function () { $(this).parent()[0].__isActiveTab = true; }
  );

  this.setupEvents();
};

HEIJS.Navigation.prototype =
{
  //
  // Properties
  //
  header: null,
  layer1: null,
  layer2: null,
  layer3: null,
  mobileWidth: 699,

  //
  // Methods
  //
  handleParentHover_On: function (menu)
  {
    this.clearTimers(menu);
    var self = this;

    // show menu immediately (almost) if no other sibling menus are open
    // or if we are switching to another top-level menu
    if (menu.siblings("li").find("div.layerchild-nav:visible").length == 0
        || menu.parents("div:first").is("div.layerone-nav"))
    {
      menu[0].__showTimer = setTimeout(
        function () { self.showMenu(menu) },
        50
      );
    }
    else if (!menu.children("div.layerchild-nav").is(":visible"))
    {
      menu[0].__showTimer = setTimeout(
        function () { self.showMenu(menu) },
        100
      );
    }
  },

  handleParentHover_Off: function (menu)
  {
    this.clearTimers(menu);

    if (menu.children("div.layerchild-nav").is(":visible"))
    {
      var self = this;
      menu[0].__hideTimer = setTimeout(
        function () { self.closeMenu(menu); },
        500
      );
    }
  },

  clearTimers: function (menu)
  {
    if (typeof (menu[0].__hideTimer) != "undefined")
    {
      clearTimeout(menu[0].__hideTimer);
    }

    if (typeof (menu[0].__showTimer) != "undefined")
    {
      clearTimeout(menu[0].__showTimer);
    }
  },

  showMenu: function (menu)
  {
    if (menu.length == 0)
    {
      return;
    }
	
	menu.addClass('menu-open');

    // close other, same-level, open fly-outs
    this.closeMenu(menu.parent().children("li:has(div.layerchild-nav:visible)").not(menu));
    var childNav = menu.children("div.layerchild-nav");

    if (!childNav.is(":visible"))
    {
      childNav
        .show()
        .children("div.scroller-top").css("visibility", "hidden")
        .siblings("div.scroller-bottom").css("visibility", "visible")
        .siblings("ul")
          .scrollTop(0);
    }

    if (childNav[0].__sized != true)
    {
      var menuWidth = childNav.width(); // SP-149
      var menuHeight = childNav.height();
      var pageSpace = $(window).height() - childNav.offset().top - $("div.bottom").height();

      if (menuHeight >= pageSpace)
      {
        childNav[0].__sized = true;
        childNav
          .attr("sized", true)
          .prepend("<div class='scroller-top'><i class='fa fa-caret-up'></i></div>")
          .append("<div class='scroller-bottom'><i class='fa fa-caret-down'></i></div>")
          .children("ul")
            .height(pageSpace - 25)
            .css("overflow", "hidden");
			
		var self = this;
		childNav.children("div.scroller-bottom,div.scroller-top").bind("mouseenter", function (e) { $(this).addClass("scroller-hover"); });
		childNav.children("div.scroller-bottom,div.scroller-top").bind("mouseleave", function (e)
		  {
			clearInterval($(this)[0].__downTimer);
			clearInterval($(this)[0].__upTimer);
			$(this).removeClass("scroller-hover");
		  });
		
		childNav.children("div.scroller-bottom").bind("mouseenter", function (e)
		  {
			var scroller = $(this);
			self.scrollLayerChildDown(scroller);
			scroller[0].__downTimer = setInterval(function () { self.scrollLayerChildDown(scroller); }, 100);
		  });
		  
		childNav.children("div.scroller-top").bind("mouseenter", function (e)
		  {
			var scroller = $(this);
			self.scrollLayerChildUp(scroller);
			scroller[0].__upTimer = setInterval(function () { self.scrollLayerChildUp(scroller); }, 100);
		  });
      }
    }
    else if (childNav[0].__doResize == true)
    {
      childNav.children("ul").css("height", "auto");
      childNav[0].__doResize = false;

      var menuHeight = childNav.height();
      var pageSpace = $(window).height() - childNav.offset().top - $("div.bottom").height();

      if (menuHeight >= pageSpace)
        childNav.children("ul").height(pageSpace - 25);
      else
      {
        childNav
          .children("div.scroller-top").css("visibility", "hidden")
          .siblings("div.scroller-bottom").css("visibility", "hidden");
      }
    }

    if (menu.is(".flyout-link"))
    {
      menu.addClass("flyout-link-selected");
      menu.children("a").addClass("flyout-anchor-selected");
    }
    else
    {
      menu.addClass("visible-link-selected");
      menu.children("a").addClass("visible-anchor-selected");
    }
  },

  closeMenu: function (menu)
  {
    if (menu.length == 0)
    {
      return;
    }
	
	menu.removeClass('menu-open');

    clearTimeout(menu[0].__hideTimer);
    menu.children("div.layerchild-nav").hide();

    if (typeof (menu[0].__isActiveTab) == "undefined" || !menu[0].__isActiveTab)
    {
      if (menu.is(".flyout-link"))
      {
        menu.removeClass("flyout-link-selected");
        menu.children("a").removeClass("flyout-anchor-selected");
      }
      else
      {
        menu.removeClass("visible-link-selected");
        menu.children("a").removeClass("visible-anchor-selected");
      }
    }
  },

  closeAll: function (layer)
  {
    layer.find("div.layerchild-nav:visible").hide();
  },

  scrollLayerChildUp: function (scroller)
  {
    var list = scroller.siblings("ul");
    var originalScrollTop = list.scrollTop();
    list.scrollTop(originalScrollTop - 15);
    scroller.siblings("div.scroller-bottom").css("visibility", "visible");

    if (list.scrollTop() == 0)
      scroller.css("visibility", "hidden");
  },

  scrollLayerChildDown: function (scroller)
  {
    var list = scroller.siblings("ul");
    var originalScrollTop = list.scrollTop();
    list.scrollTop(originalScrollTop + 15);
    scroller.siblings("div.scroller-top").css("visibility", "visible");

    if (list.scrollTop() == originalScrollTop)
      scroller.css("visibility", "hidden");
  },
  
  isMobile: function () {
    return $(window).width() <= this.mobileWidth;
  },
  
  getPathName: function (anchor) {
    var urlWithoutProtocol = anchor.href.split('//')[1];
    return urlWithoutProtocol.substr(urlWithoutProtocol.indexOf('/'));
  },

  setupEvents: function ()
  {
    var self = this;
	function ezbAddEvent(object,oEvent,fnctn){
		if(object.addEventListener) object.addEventListener(oEvent,fnctn,false);
		else if(object.attachEvent) object.attachEvent("on" + oEvent, fnctn);
	}
	ezbAddEvent(window,"load",function(e){
    if (self.isMobile()) { 
      return;
    }
    
		ezbAddEvent(document,"mouseout",function(e){
      if (self.isMobile()) { 
        return;
      }
      
			e = e ? e : window.event;
			var from = e.relatedTarget || e.toElement;
			if(!from || from.nodeName == "HTML") {
				self.closeAll(self.layer1); 
				self.closeAll(self.layer2); 
				self.closeAll(self.layer3); 
				$('div.layerone-nav').find('.visible-anchor-selected').removeClass('visible-anchor-selected');
			}
		});
	});
    $(document).click(function (e) { 
      if (self.isMobile()) {
        var $firstOpenSubNavIcon = $('i.openSubNavIcon:first');
        
        if ($firstOpenSubNavIcon.length > 0 && !$firstOpenSubNavIcon.is(':hover') && !$('div.layertwo-nav:first').is(':hover')) {
          clearTimeout(window.hideGlobalSubNavTimer);
          
          var $target = $(e.target);
          
          if ($target.hasClass('itemInNavBar') || $target.parents('div.globalNavMobileUserControl:first').length > 0) {
            return;
          }
          
          window.hideGlobalSubNavTimer = window.setTimeout(function () {
            $('body').removeClass('mobileGlobalSubNavOpen');
          }, 100);
        }
        
        return;
      }
      
      self.closeAll(self.layer1); 
      self.closeAll(self.layer2); 
      self.closeAll(self.layer3);
    });
    
    $("iframe").each(function ()
    {
      try
      {
        $(this.contentWindow.document).click(function (e) { self.closeAll(self.layer1); self.closeAll(self.layer3); });
      }
      catch (e) { }
    });
    $(window).bind("resize.navigation", function () { $("div.layerchild-nav[sized=true]").each(function (i, d) { d.__doResize = true; }); });

    // hover events for layer one navigation
    // the parent of a horizontal-flyout wrapper is the LI element
    // of the main navigation
    var itemInit = function ()
    {
      var item = $(this);
      if (item.children("div.layerchild-nav").length > 0)
      {
        item
          .on('mouseenter', function () {
            if (self.isMobile()) {
              return;
            }
            
            self.handleParentHover_On($(this));
          })
          .on('mouseleave', function () {
            if (self.isMobile()) {
              return;
            }
            
            self.handleParentHover_Off($(this)); 
          })
          .on('click', function (e) {
            if (!self.isMobile()) {
              return;
            }
            
            var $this = $(e.target).parents('li:first');
			
            if (!$this.hasClass('has-children')) {
              return;
            }
            
            if ($this.hasClass('menu-open')) {
              self.closeMenu($this);
            }
            else {
              self.showMenu($this);
            }
            
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            return false;
          })
        
		if (!self.isMobile()) {
		  self.handleParentHover_On(item);
		}

        item.children("div.layerchild-nav").children("ul").children("li").one("mouseover.iteminit", itemInit);
      }
	  
	  item.children("a:not([href*='#'])").on('click', function () {
	    if (!self.isMobile()) {
		  self.closeAll(item.parents(".layerone-nav,.layertwo-nav")); 
	    }
	  });
    };

    this.layer1.children("li").one("mouseover.iteminit", itemInit);
    this.layer2.children("li").one("mouseover.iteminit", itemInit);
    this.layer3.children("li").one("mouseover.iteminit", itemInit);
    
    $('div.globalNavMobileMenuIconContainer').off('click.globalNav').on('click.globalNav', function () {
      var $body = $('body');
      
      if (!$body.hasClass('mobileGlobalNavOpen')) {
        var $allAnchors = self.header.find('a.flyout-anchor')
        var $selectedAnchor = $allAnchors.filter(function (i, anchor) { return self.getPathName(anchor) === window.location.pathname });
        
        if (!$selectedAnchor.hasClass('selected-flyout-anchor')) {
          $allAnchors.filter('.selected-flyout-anchor').removeClass('selected-flyout-anchor');
          $selectedAnchor.addClass('selected-flyout-anchor');
        }
        
        if ($selectedAnchor.length > 0) {          
          $selectedAnchor.parents('li.has-children').each(function (i, item) {
            self.showMenu($(item));
          });
          
          self.header.scrollTop(self.header.scrollTop() + ($selectedAnchor.offset().top - self.header.offset().top - self.header[0].clientHeight + $selectedAnchor.outerHeight()));
        }
      }      
      
      $('body').toggleClass('mobileGlobalNavOpen');
    });
    
    $('i.openSubNavIcon').off('click.globalNav').on('click.globalNav', function () {
      $('body').toggleClass('mobileGlobalSubNavOpen');
    });
  }
};

$(document).ready(function () { HEIJS.page.navigation = new HEIJS.Navigation(); });